import { useContext, useEffect, useState, useRef } from 'react'
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { getExampleNumber } from "libphonenumber-js";
import examples from "libphonenumber-js/examples.mobile.json";
import { Link, useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from "react-secure-storage";
import { useTranslation } from 'react-i18next';
import Btn_loader from '../Btn_loader';

const Login = () => {

    const { t } = useTranslation();
    const { setIsToast, setToastMsg, setUserLogin, HandleCallApi, setIsAuth } = useContext(MyContext);

    const [number, setNumber] = useState("");
    const [digits, setDigits] = useState("");
    const [passtype, setPassType] = useState("Password");
    const [apiloading, setApiLoading] = useState(false);
    const [password, setPassowrd] = useState("");
    const [showCcode, setShowCcode] = useState(false);
    const [searchCcode, setSearchCcode] = useState("");
    const [selectCcode, setSelectCcode] = useState("+91");

    const navigate = useNavigate();

    const countries = getCountries();
    const FilterCCode = countries.filter((item) => getCountryCallingCode(item).toString().includes(searchCcode));

    useEffect(() => {
        getMobileLengthFromCallingCode("IN");
    }, []);

    const ccodeRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ccodeRef.current && !ccodeRef.current.contains(event.target)) {
                setShowCcode(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleCheckNumber = async (e) => {
        e.preventDefault();

        if (!number || !password) {
            setIsToast(true);
            setToastMsg("Enter Login Details !!");
            return;
        }

        setApiLoading(true);

        const ApiData = {
            c_code: selectCcode,
            phone: number,
            email: ""
        }

        const Response = await HandleCallApi("Post", "user/detail_check", ApiData);
        const { ResponseCode, number_result, email_result, message } = Response.data;

        if (ResponseCode === 200) {
            if (number_result === true || email_result === true) {
                setIsToast(true);
                setToastMsg(message);
                setApiLoading(false);
                return;
            }

            if (number_result === false || email_result === false) {
                handleLogin();
            }
        }

        setApiLoading(false);
    }

    const handleLogin = async () => {
        const ApiData = {
            c_code: selectCcode,
            ulogin_data: number,
            password: password
        }

        const Response = await HandleCallApi("Post", "user/login", ApiData);
        const { ResponseCode, message, customer } = Response.data;

        setIsToast(true);
        setToastMsg(message);

        if (ResponseCode === 200) {
            setIsAuth(true);
            setUserLogin(prev => prev + 1);
            secureLocalStorage.setItem("Logindata", JSON.stringify(customer));
            secureLocalStorage.setItem("Userid", customer.id);
            secureLocalStorage.setItem("isAuthenticated", true);
            navigate("/");
        }
        setApiLoading(false);

    }

    const handleSelectCuntryCode = async (item) => {
        setSelectCcode(`+${getCountryCallingCode(item)}`);
        getMobileLengthFromCallingCode(item);
        setShowCcode(false);
    }

    const getMobileLengthFromCallingCode = (country) => {
        const exampleNumber = getExampleNumber(country.toUpperCase(), examples);
        if (exampleNumber) {
            setDigits(exampleNumber.nationalNumber.length);
        }
    };

    return (
        <div className='auth_bg'>
            <div className='auth_deco_1'></div>
            <div className='auth_deco_2'></div>
            <div className='auth_deco_3'></div>

            <div className='auth_card'>
                <div className='text-center mb-8'>
                    <h1 className='text-2xl md:text-3xl font-extrabold text-gray-800 mb-2'>{t("Welcome Back!")}</h1>
                    <p className='text-gray-500 text-sm'>{t("Sign in to your account")}</p>
                </div>

                <form onSubmit={handleCheckNumber}>
                    <div className='mb-5'>
                        <label className='auth_label'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>
                            {t("Phone Number")}
                        </label>
                        <div className='relative' ref={ccodeRef}>
                            <div className='auth_input_wrap'>
                                <div onClick={() => setShowCcode(!showCcode)} className='flex items-center gap-1 cursor-pointer text-gray-500 hover:text-gray-700 transition-colors'>
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 14.75C11.808 14.75 11.616 14.6771 11.47 14.5301L7.46999 10.5301C7.17699 10.2371 7.17699 9.76202 7.46999 9.46902C7.76299 9.17602 8.23803 9.17602 8.53103 9.46902L12.001 12.939L15.471 9.46902C15.764 9.17602 16.239 9.17602 16.532 9.46902C16.825 9.76202 16.825 10.2371 16.532 10.5301L12.532 14.5301C12.384 14.6771 12.192 14.75 12 14.75Z" fill="currentColor" /></svg>
                                    <span className='text-sm font-medium'>{selectCcode}</span>
                                </div>
                                <div className='w-px h-5 bg-gray-200'></div>
                                <input type="tel" maxLength={digits} value={number} onChange={(e) => setNumber(e.target.value)} placeholder={t('Enter your number')} />
                            </div>

                            {showCcode && <div className='auth_ccode_dropdown'>
                                <input type="number" value={searchCcode} onChange={(e) => setSearchCcode(e.target.value)} placeholder={t("Search")} />
                                <ul>
                                    {FilterCCode.map((item, index) => (
                                        <li key={index} onClick={() => handleSelectCuntryCode(item)}>+{getCountryCallingCode(item)}</li>
                                    ))}
                                </ul>
                            </div>}
                        </div>
                    </div>

                    <div className='mb-4'>
                        <label className='auth_label'>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.75 8.30396V7C16.75 4.381 14.619 2.25 12 2.25C9.381 2.25 7.25 4.381 7.25 7V8.30396C5.312 8.56096 4.25 9.846 4.25 12V18C4.25 20.418 5.582 21.75 8 21.75H16C18.418 21.75 19.75 20.418 19.75 18V12C19.75 9.847 18.688 8.56195 16.75 8.30396ZM12 3.75C13.792 3.75 15.25 5.208 15.25 7V8.25H8.75V7C8.75 5.208 10.208 3.75 12 3.75ZM18.25 18C18.25 19.577 17.577 20.25 16 20.25H8C6.423 20.25 5.75 19.577 5.75 18V12C5.75 10.423 6.423 9.75 8 9.75H16C17.577 9.75 18.25 10.423 18.25 12V18ZM13.27 14C13.27 14.412 13.058 14.7601 12.75 14.9871V17C12.75 17.414 12.414 17.75 12 17.75C11.586 17.75 11.25 17.414 11.25 17V14.9619C10.962 14.7329 10.7649 14.395 10.7649 14C10.7649 13.31 11.32 12.75 12.01 12.75H12.02C12.71 12.75 13.27 13.31 13.27 14Z" fill="currentColor" /></svg>
                            {t("Password")}
                        </label>
                        <div className='auth_input_wrap'>
                            <input type={passtype} value={password} onChange={(e) => setPassowrd(e.target.value)} placeholder={t('Enter your password')} />
                            <div className='auth_icon_btn' onClick={() => setPassType(passtype === "Password" ? "text" : "Password")}>
                                {passtype === "Password"
                                    ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.229 13.8679C19.913 16.0639 16.96 19.75 12 19.75C11.037 19.75 10.0861 19.604 9.17408 19.315C8.77908 19.19 8.56105 18.769 8.68605 18.374C8.81005 17.978 9.23496 17.762 9.62696 17.885C10.392 18.127 11.19 18.25 12 18.25C16.222 18.25 18.7901 15.02 19.9441 13.094C20.3521 12.418 20.3521 11.581 19.9461 10.907C19.6001 10.324 19.177 9.72798 18.72 9.17898C18.455 8.85998 18.4991 8.38707 18.8181 8.12307C19.1381 7.85807 19.61 7.90199 19.875 8.21999C20.381 8.82899 20.8509 9.49199 21.2329 10.137C21.9259 11.284 21.926 12.7159 21.229 13.8679ZM10.063 14.9981L3.53004 21.531C3.38404 21.677 3.19201 21.751 3.00001 21.751C2.80801 21.751 2.61598 21.678 2.46998 21.531C2.17698 21.238 2.17698 20.763 2.46998 20.47L5.64503 17.2949C4.31703 16.1499 3.35205 14.837 2.76905 13.866C2.07505 12.716 2.07501 11.2841 2.77101 10.1331C4.08701 7.93708 7.04001 4.251 12 4.251C13.835 4.251 15.565 4.76994 17.155 5.78494L20.469 2.47097C20.762 2.17797 21.237 2.17797 21.53 2.47097C21.823 2.76397 21.823 3.23901 21.53 3.53201L10.065 14.9971C10.065 14.9971 10.065 14.9981 10.064 14.9981C10.063 14.9981 10.063 14.9971 10.063 14.9981ZM9.6089 13.3311L13.3311 9.60891C12.9291 9.38191 12.478 9.251 12 9.251C10.484 9.251 9.25099 10.484 9.25099 12.001C9.25099 12.478 9.3829 12.9291 9.6089 13.3311ZM6.70704 16.232L8.51905 14.4199C8.02405 13.7169 7.75099 12.882 7.75099 11.999C7.75099 9.65605 9.65701 7.74905 12 7.74905C12.884 7.74905 13.7179 8.02211 14.4209 8.51711L16.052 6.88601C14.787 6.14501 13.432 5.74807 12 5.74807C7.77801 5.74807 5.20992 8.97808 4.05592 10.9041C3.64792 11.5801 3.64797 12.4171 4.05397 13.0911C4.59097 13.9881 5.48304 15.201 6.70704 16.232ZM14.708 12.4351C14.528 13.5951 13.594 14.53 12.436 14.709C12.027 14.772 11.7461 15.155 11.8091 15.564C11.8671 15.935 12.1861 16.2 12.5491 16.2C12.5871 16.2 12.6261 16.1969 12.6641 16.1909C14.4911 15.9089 15.908 14.4921 16.19 12.6641C16.253 12.2541 15.973 11.8721 15.563 11.8081C15.163 11.7471 14.771 12.0251 14.708 12.4351Z" fill="currentColor" /></svg>
                                    : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.2352 10.1379C19.9222 7.93894 16.9751 4.25 12.0001 4.25C7.02511 4.25 4.07801 7.93894 2.76501 10.1379C2.07801 11.2859 2.07801 12.7131 2.76501 13.8621C4.07801 16.0611 7.02511 19.75 12.0001 19.75C16.9751 19.75 19.9222 16.0611 21.2352 13.8621C21.9222 12.7131 21.9222 11.2869 21.2352 10.1379ZM19.9481 13.092C18.7981 15.018 16.2351 18.25 12.0001 18.25C7.76511 18.25 5.20212 15.019 4.05212 13.092C3.65012 12.418 3.65012 11.581 4.05212 10.907C5.20212 8.98098 7.76511 5.74902 12.0001 5.74902C16.2351 5.74902 18.7981 8.97998 19.9481 10.907C20.3511 11.582 20.3511 12.418 19.9481 13.092ZM12.0001 7.75C9.65611 7.75 7.75011 9.657 7.75011 12C7.75011 14.343 9.65611 16.25 12.0001 16.25C14.3441 16.25 16.2501 14.343 16.2501 12C16.2501 9.657 14.3441 7.75 12.0001 7.75ZM12.0001 14.75C10.4831 14.75 9.25011 13.517 9.25011 12C9.25011 10.483 10.4831 9.25 12.0001 9.25C13.5171 9.25 14.7501 10.483 14.7501 12C14.7501 13.517 13.5171 14.75 12.0001 14.75Z" fill="currentColor" /></svg>
                                }
                            </div>
                        </div>
                    </div>

                    <div className='text-right mb-6'>
                        <Link to="/auth/forgot-password" className='text-sm font-semibold text-orange-500 hover:text-orange-600 transition-colors'>{t("Forgot Password?")}</Link>
                    </div>

                    <button type='submit' className='auth_btn_primary' disabled={apiloading}>
                        {apiloading ? <Btn_loader CustomeStyle={"bg-white"} /> : t("Sign In")}
                    </button>

                    <div className='text-center mt-6'>
                        <span className='text-sm text-gray-500'>{t("Don't have an account?")}</span>
                        <Link to="/auth/signup" className='text-sm font-semibold text-orange-500 hover:text-orange-600 ml-1 transition-colors'>{t("Sign Up")}</Link>
                    </div>
                </form>
            </div>

        </div>
    )
}

export default Login